<template>
  <el-dialog
    title="日切维护"
    :visible="visible"
    :width="sending ? '420px' : '720px'"
    :destroy-on-close="true"
    :lock-scroll="false"
    :close-on-click-modal="!loading"
    :close-on-press-escape="!loading"
    :show-close="!loading"
    append-to-body
    custom-class="ele-dialog-form"
    @update:visible="updateVisible"
    @close="onClose">
    <el-form
      v-if="!sending"
      ref="form"
      v-loading="listLoading"
      :model="form"
      :rules="rules"
      label-width="48px"
      @submit.native.prevent>
      <el-form-item label="商户" prop="user_ids">
        <div class="day-cut-toolbar">
          <el-checkbox
            :indeterminate="indeterminate"
            :value="checkAll"
            @change="onCheckAll">全选</el-checkbox>
          <span class="day-cut-count">已选 {{ form.user_ids.length }} / {{ merchantList.length }}</span>
        </div>
        <el-checkbox-group v-model="form.user_ids" class="day-cut-list">
          <el-checkbox
            v-for="item in merchantList"
            :key="item.id"
            :label="item.id"
            class="day-cut-item">
            {{ item.username }} {{ item.realname }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input
          v-model="form.content"
          type="textarea"
          :rows="5"
          maxlength="2000"
          show-word-limit
          placeholder="请输入" />
      </el-form-item>
    </el-form>
    <template v-else>
      <div v-loading="loading && percent === 0">{{ tip }}</div>
      <el-progress
        style="margin-top: 16px"
        :percentage="percent"
        :status="percent >= 100 ? 'success' : undefined" />
      <div style="margin-top: 10px; color: #909399; font-size: 13px">
        {{ processed }} / {{ total }}
      </div>
    </template>
    <div slot="footer">
      <template v-if="sending">
        <el-button v-if="loading" @click="cancel">取消</el-button>
        <el-button v-else type="primary" @click="updateVisible(false)">关闭</el-button>
      </template>
      <template v-else>
        <el-button @click="updateVisible(false)">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
const RULES = {
  user_ids: [{ type: 'array', required: true, min: 1, message: '请选择', trigger: 'change' }],
  content: [{ required: true, whitespace: true, message: '请输入', trigger: 'blur' }]
};

export default {
  name: 'DayCutDialog',
  props: {
    visible: Boolean
  },
  data() {
    return {
      listLoading: false,
      loading: false,
      sending: false,
      aborted: false,
      merchantList: [],
      form: {
        user_ids: [],
        content: ''
      },
      rules: RULES,
      tip: '',
      percent: 0,
      processed: 0,
      total: 0
    };
  },
  computed: {
    checkAll() {
      const total = this.merchantList.length;
      return total > 0 && this.form.user_ids.length === total;
    },
    indeterminate() {
      const n = this.form.user_ids.length;
      return n > 0 && n < this.merchantList.length;
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadMerchants();
      } else {
        this.reset();
      }
    }
  },
  methods: {
    updateVisible(value) {
      if (this.loading && !value) return;
      this.$emit('update:visible', value);
    },
    reset() {
      this.listLoading = false;
      this.loading = false;
      this.sending = false;
      this.aborted = false;
      this.merchantList = [];
      this.form.user_ids = [];
      this.form.content = '';
      this.tip = '';
      this.percent = 0;
      this.processed = 0;
      this.total = 0;
    },
    onCheckAll(val) {
      this.form.user_ids = val ? this.merchantList.map((item) => item.id) : [];
    },
    loadMerchants() {
      this.listLoading = true;
      this.form.user_ids = [];
      this.$http
        .get('/Channeltype/listDayCutMerchants')
        .then((res) => {
          this.listLoading = false;
          if (res.data.code === 0) {
            this.merchantList = res.data.data || [];
            return;
          }
          this.merchantList = [];
          this.$message.error(res.data.msg);
        })
        .catch((e) => {
          this.listLoading = false;
          this.merchantList = [];
          this.$message.error(e.message);
        });
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) this.sendNotice();
      });
    },
    async sendNotice() {
      const text = this.form.content.trim();
      const ids = this.form.user_ids;
      const total = ids.length;
      this.sending = true;
      this.loading = true;
      this.aborted = false;
      this.tip = '正在发送...';
      this.percent = 0;
      this.processed = 0;
      this.total = total;

      let ok = 0;
      let fail = 0;
      try {
        for (let i = 0; i < total; i++) {
          if (this.aborted) break;
          try {
            const res = await this.$http.post('/Channeltype/sendDayCutNotice', {
              user_ids: [ids[i]],
              content: text
            });
            if (res.data.code === 0) ok++;
            else fail++;
          } catch (e) {
            fail++;
          }
          this.processed = i + 1;
          this.percent = Math.round(((i + 1) / total) * 100);
        }

        if (this.aborted) {
          this.tip = '已取消';
          return;
        }

        this.percent = 100;
        if (ok <= 0) {
          this.tip = '发送失败';
          this.$message.error(this.tip);
          return;
        }
        this.tip = fail ? `发送成功 ${ok} 个，失败 ${fail} 个` : `发送成功 ${ok} 个`;
        this.$message.success(this.tip);
        this.$emit('update:visible', false);
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.aborted = true;
      this.tip = '正在取消...';
    },
    onClose() {
      if (this.loading) this.aborted = true;
    }
  }
};
</script>

<style scoped>
.day-cut-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.day-cut-count {
  color: #909399;
  font-size: 12px;
}
.day-cut-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px 8px;
  max-height: 280px;
  overflow-y: auto;
  padding: 8px 12px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
.day-cut-item {
  margin: 0;
  padding: 6px 0;
  line-height: 1.4;
  overflow: hidden;
}
.day-cut-item >>> .el-checkbox__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>
